<template>
  <div class="main">
    <div
      style="height:120px;font-size:40px;font-weight:bold;text-align:center;padding-top:5px;letter-spacing:5px;line-height:120px"
    ></div>
    <div class="home" @click="gohome"></div>
    <div class="navyin" @click="gozhihui"></div>
    <div class="chart1" v-if="true">
      <div class="myChart">
        <div id="myChart1" style="height:260px;width:100%"></div>
      </div>
    </div>
    <div
      class="chart2"
      style="display:flex;margin-left:1%;justify-content: center;align-items: center;fontSize:20px"
    >
      <div style="flex:1">
        <el-row>
          <el-col style="width:150px">环境污染</el-col>
          <el-col style="width:210px;">
            <svgprogress type="rect" :options="options" value="65"></svgprogress>
          </el-col>
          <el-col style="width:50px">183</el-col>
        </el-row>
        <el-row>
          <el-col style="width:150px">非法采矿</el-col>
          <el-col style="width:210px;">
            <svgprogress type="rect" :options="options" value="75"></svgprogress>
          </el-col>
          <el-col style="width:50px">176</el-col>
        </el-row>
        <el-row>
          <el-col style="width:150px">生产、销售不符合安全标准食品</el-col>
          <el-col style="width:210px;">
            <svgprogress type="rect" :options="options" value="35"></svgprogress>
          </el-col>
          <el-col style="width:50px">135</el-col>
        </el-row>
        <el-row>
          <el-col style="width:150px">盗伐林地</el-col>
          <el-col style="width:210px;">
            <svgprogress type="rect" :options="options" value="75"></svgprogress>
          </el-col>
          <el-col style="width:50px">171</el-col>
        </el-row>
      </div>
      <div style="flex:1">
        <el-row>
          <el-col style="width:150px">生产、销售假药</el-col>
          <el-col style="width:210px;">
            <svgprogress type="rect" :options="options" value="35"></svgprogress>
          </el-col>
          <el-col style="width:50px">135</el-col>
        </el-row>
        <el-row>
          <el-col style="width:150px">生产、销售劣药</el-col>
          <el-col style="width:210px;">
            <svgprogress type="rect" :options="options" value="36"></svgprogress>
          </el-col>
          <el-col style="width:50px">137</el-col>
        </el-row>
        <el-row>
          <el-col style="width:150px">非法占有草原</el-col>
          <el-col style="width:210px;">
            <svgprogress type="rect" :options="options" value="57"></svgprogress>
          </el-col>
          <el-col style="width:50px">158</el-col>
        </el-row>
        <el-row>
          <el-col style="width:150px">其它</el-col>
          <el-col style="width:210px;">
            <svgprogress type="rect" :options="options" value="27"></svgprogress>
          </el-col>
          <el-col style="width:50px">127</el-col>
        </el-row>
      </div>
    </div>
    <div class="chart3" v-if="true" style="display:flex;align-items:center;">
      <div style="flex:1;color:#fff;fontSize:21px">
        <el-row type="flex" style="margin:0px 70px;">
          <el-col>
            <svgprogress type="circle" :options="options3" value="272"></svgprogress>
            <div>行政许可</div>
          </el-col>
          <el-col>
            <svgprogress type="circle" :options="options3" value="24"></svgprogress>
            <div>行政奖励</div>
          </el-col>
          <el-col>
            <svgprogress type="circle" :options="options3" value="1998"></svgprogress>
            <div>行政处罚</div>
          </el-col>
        </el-row>
        <div class="chart3part2">
          <el-row type="flex" style="color:#fff;fontSize:21px">
            <el-col style="margin-left:10px;">
              <svgprogress type="circle" :options="options3" value="81"></svgprogress>
              <div>行政强制措施</div>
            </el-col>
            <el-col style="margin-left:70px;">
              <svgprogress type="circle" :options="options3" value="15"></svgprogress>
              <div>行政强制执行</div>
            </el-col>
            <el-col style="margin-left:70px;">
              <svgprogress type="circle" :options="options3" value="173"></svgprogress>
              <div>行政监督检查</div>
            </el-col>
            <el-col style="margin-left:70px;">
              <svgprogress type="circle" :options="options3" value="67"></svgprogress>
              <div>其他行政权力</div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="chart4" v-if="false">
      <div id="myChart4" style="height:100%;width:100%"></div>
    </div>
    <div class="chart5" v-if="true">
      <div id="myChart5" style="height:100%;width:100%"></div>
    </div>
    <div class="chart6" v-if="true">
      <div id="myChart6" style="height:100%;width:100%"></div>
    </div>
    <div class="chart7" v-if="false">
      <div id="myChart7" style="height:100%;width:100%"></div>
    </div>
    <div class="chart8" v-if="false">
      <div id="myChart8" style="height:100%;width:100%"></div>
    </div>

    <!-- 行政级别与发证机关 -->
    <div class="xingzhengjibie" id="xingzhengjibie"></div>
    <div class="fazhengjiguan" id="fazhengjiguan"></div>
  </div>
</template>

<script>
import G2World from "./g2world.vue";
import svgprogress from "svg-progress-bar";
export default {
  name: "Index",
  components: {
    G2World,
    svgprogress
  },
  data() {
    return {
      serverData: [],
      options: {
        rectRadius: 8,
        gradientColor: ["rgb(114, 150, 236)", "rgb(83,233, 222)"],
        varyStrokeArray: [30, 25],
        textColor: "rgba(0,0,0,0)",
        pathColors: ["#6387ae", "#0a2e48"]
      },
      options3: {
        pathColors: ["#1b475c", "#54e8df"],
        textColor: "#FFF",
        maxValue: 3000
      }
    };
  },
  props: {},
  mounted: function () {
    //this.myChart1();
    //this.myChart2();
    //this.myChart3();
    //this.myChart4();
    this.myChart5();
    this.myChart6();
    //this.myChart7();
    //this.myChart8();
    this.xingzhengjibie();
    this.fazhengjiguan();
  },
  methods: {
    xingzhengjibie() {
      let data = [
        {
          name: "国家法律",
          value: 13211
        },
        {
          name: "部委规章",
          value: 42111
        },
        {
          name: "司法解释",
          value: 81711
        },
        {
          name: "地方法规与规章库",
          value: 121711
        }
      ];
      let arrName = getArrayValue(data, "name");
      let arrValue = getArrayValue(data, "value");
      let sumValue = eval(arrValue.join("+"));
      let objData = array2obj(data, "name");
      let optionData = getData(data);

      function getArrayValue(array, key) {
        var key = key || "value";
        var res = [];
        if (array) {
          array.forEach(function (t) {
            res.push(t[key]);
          });
        }
        return res;
      }

      function array2obj(array, key) {
        var resObj = {};
        for (var i = 0; i < array.length; i++) {
          resObj[array[i][key]] = array[i];
        }
        return resObj;
      }

      function getData(data) {
        var res = {
          series: [],
          yAxis: []
        };
        for (let i = 0; i < data.length; i++) {
          res.series.push({
            name: "行政级别",
            type: "pie",
            clockWise: true, //顺时加载
            hoverAnimation: false, //鼠标移入变大
            radius: [100 - i * 15 + "%", 85 - i * 15 + "%"],
            center: ["50%", "50%"],
            label: {
              show: false
            },
            itemStyle: {
              label: {
                show: false
              },
              labelLine: {
                show: false
              },
              borderWidth: 5
            },
            data: [
              {
                value: data[i].value,
                name: data[i].name
              },
              {
                value: sumValue - data[i].value,
                name: "",
                itemStyle: {
                  color: "rgba(9,47,73,0.8)",
                  borderWidth: 0
                },
                tooltip: {
                  show: false
                },
                hoverAnimation: false
              }
            ]
          });
          res.series.push({
            name: "",
            type: "pie",
            silent: true,
            z: 1,
            clockWise: true, //顺时加载
            hoverAnimation: false, //鼠标移入变大
            radius: [100 - i * 15 + "%", 85 - i * 15 + "%"],
            center: ["50%", "50%"],
            label: {
              show: false
            },
            itemStyle: {
              label: {
                show: false
              },
              labelLine: {
                show: false
              },
              borderWidth: 5
            },
            data: [
              {
                value: 7.5,
                itemStyle: {
                  color: "rgba(255,255,255,.4)",
                  borderWidth: 0
                },
                tooltip: {
                  show: false
                },
                hoverAnimation: false
              },
              {
                value: 2.5,
                name: "",
                itemStyle: {
                  color: "rgba(0,0,0,0)",
                  borderWidth: 0
                },
                tooltip: {
                  show: false
                },
                hoverAnimation: false
              }
            ]
          });
          res.yAxis.push(((data[i].value / sumValue) * 100).toFixed(2));
        }
        return res;
      }

      let myChart = this.$echarts.init(
        document.getElementById("xingzhengjibie")
      );
      myChart.setOption({
        tooltip: {
          show: true,
          trigger: "item",
          formatter: "{a}<br>{b}:{c}({d}%)"
        },
        // color: ["#FF8700", "#ffc300", "#00e473", "#009DFF"],
        color: ["#5693af"],
        grid: {
          top: "17%",
          bottom: "48%",
          left: "30%",
          containLabel: false
        },
        yAxis: [
          {
            type: "category",
            inverse: true,
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              interval: 0,
              inside: true,
              lineHeight: 18,
              textStyle: {
                color: "#fff",
                fontSize: 18,
                rich: {
                  a: {
                    fontSize: 12
                  }
                }
              },

              show: true,
              margin: 60,
              align: "right",
              padding: [-85, 0, 0, 0]
            },
            data: arrName,
            z: 9999
          }
        ],
        xAxis: [
          {
            show: false
          }
        ],
        series: optionData.series
      });
    },
    fazhengjiguan() {
      let data = [
        {
          name: "国务院",
          value: 13211
        },
        {
          name: "地方政府",
          value: 42111
        },
        {
          name: "最高人民法院",
          value: 81711
        },
        {
          name: "最高人民检察院",
          value: 121711
        }
      ];
      let arrName = getArrayValue(data, "name");
      let arrValue = getArrayValue(data, "value");
      let sumValue = eval(arrValue.join("+"));
      let objData = array2obj(data, "name");
      let optionData = getData(data);

      function getArrayValue(array, key) {
        var key = key || "value";
        var res = [];
        if (array) {
          array.forEach(function (t) {
            res.push(t[key]);
          });
        }
        return res;
      }

      function array2obj(array, key) {
        var resObj = {};
        for (var i = 0; i < array.length; i++) {
          resObj[array[i][key]] = array[i];
        }
        return resObj;
      }

      function getData(data) {
        var res = {
          series: [],
          yAxis: []
        };
        for (let i = 0; i < data.length; i++) {
          res.series.push({
            name: "发布机关",
            type: "pie",
            clockWise: true, //顺时加载
            hoverAnimation: false, //鼠标移入变大
            radius: [100 - i * 15 + "%", 85 - i * 15 + "%"],
            center: ["50%", "50%"],
            label: {
              show: false
            },
            itemStyle: {
              label: {
                show: false
              },
              labelLine: {
                show: false
              },
              borderWidth: 5
            },
            data: [
              {
                value: data[i].value,
                name: data[i].name
              },
              {
                value: sumValue - data[i].value,
                name: "",
                itemStyle: {
                  // color: "rgba(0,0,0,0)",
                  color: "rgba(9,47,73,0.8)",
                  borderWidth: 0
                },
                tooltip: {
                  show: false
                },
                hoverAnimation: false
              }
            ]
          });
          res.series.push({
            name: "",
            type: "pie",
            silent: true,
            z: 1,
            clockWise: true, //顺时加载
            hoverAnimation: false, //鼠标移入变大
            radius: [100 - i * 15 + "%", 85 - i * 15 + "%"],
            center: ["50%", "50%"],
            label: {
              show: false
            },
            itemStyle: {
              label: {
                show: false
              },
              labelLine: {
                show: false
              },
              borderColor: "#3ea4a9",
              borderWidth: 1
            },
            data: [
              {
                value: 7.5,
                itemStyle: {
                  color: "rgba(255,255,255,0.4)",
                  borderWidth: 1
                },
                tooltip: {
                  show: false
                },
                hoverAnimation: false
              },
              {
                value: 2.5,
                name: "",
                itemStyle: {
                  color: "rgba(0,0,0,0)",
                  borderWidth: 0
                },
                tooltip: {
                  show: false
                },
                hoverAnimation: false
              }
            ]
          });
          res.yAxis.push(((data[i].value / sumValue) * 100).toFixed(2));
        }
        return res;
      }

      let myChart = this.$echarts.init(
        document.getElementById("fazhengjiguan")
      );
      myChart.setOption({
        tooltip: {
          show: true,
          trigger: "item",
          formatter: "{a}<br>{b}:{c}({d}%)"
        },
        // color: ["#FF8700", "#ffc300", "#00e473", "#009DFF"],
        color: ["#5693af"],
        grid: {
          top: "17%",
          bottom: "48%",
          left: "30%",
          containLabel: false
        },
        yAxis: [
          {
            type: "category",
            inverse: true,
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              interval: 0,
              inside: true,
              lineHeight: 18,
              textStyle: {
                color: "#fff",
                fontSize: 18,
                rich: {
                  a: {
                    fontSize: 12
                  }
                }
              },

              show: true,
              margin: 60,
              align: "right",
              padding: [-85, 0, 0, 0]
            },
            data: arrName,
            z: 999
          }
        ],
        xAxis: [
          {
            show: false
          }
        ],
        series: optionData.series
      });
    },
    gohome() {
      this.$router.push({ path: "/home" });
    },
    gozhihui() {
      this.$router.push({ path: "/zhihui" });
    },
    myChart1() {
      let myChart = this.$echarts.init(
        document.getElementById("myChart1"),
        "dark"
      );
      let option = {
        backgroundColor: "",
        //color: ["#37A2DA", "#67E0E3", "#FFD85C", "#FF9F7F", "#E062AE"],
        title: {
          text: "案情情况分析",
          top: 20,
          textStyle: {
            fontSize: "18"
          }
        },
        color: [
          "#00dc9b",
          "#0566d4",
          "#dbff0d",
          "#97adfc",
          "#0bca25",
          "#749f83",
          "#ca8622",
          "#bda29a",
          "#6e7074",
          "#546570",
          "#c4ccd3"
        ],
        legend: {
          bottom: 20,
          left: 0,
          type: "scroll"
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        textStyle: {
          fontSize: "10",
          fontFamily: "bold"
        },
        visualMap: {
          show: false,
          min: 80,
          max: 600,
          inRange: {
            colorLightness: [0, 1]
          }
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: "50%",
            data: [
              { value: 335, name: "国有土地使用权" },
              { value: 310, name: "国有财产保护" },
              { value: 274, name: "生态资源与环境保护" },
              { value: 235, name: "食品与药品安全" },
              { value: 400, name: "英烈保护" }
            ],
            roseType: "radius",
            labelLine: {
              normal: {
                lineStyle: {
                  color: "rgba(255, 255, 255, 0.3)"
                },
                smooth: 0.2,
                length: 10,
                length2: 20
              }
            },
            label: {
              normal: {
                show: true,
                fontSize: 12,
                formatter: "{d}%"
              }
            }
          }
        ]
      };
      myChart.setOption(option);
    },
    myChart2() {
      let myChart = this.$echarts.init(
        document.getElementById("myChart2"),
        "dark"
      );
      let option = {
        backgroundColor: "",
        //color: ["#11ccd3"],
        color: ["#11c8d5"],
        title: {
          text: "近一月数据采集情况",
          top: 20,
          textStyle: {
            fontSize: "16"
          }
        },
        tooltip: {
          trigger: "axis"
        },
        grid: {
          top: "20%",
          left: "0%",
          right: "3%",
          bottom: "5%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: ["第一周", "第二周", "第三周", "第四周"],
          axisLabel: {
            fontSize: "12"
          },
          axisLabel: {
            color: "#21bffd"
          }
        },
        yAxis: {
          type: "value",
          axisLabel: {
            fontSize: "12",
            color: "#868686"
          }
        },
        series: [
          {
            name: "数据",
            type: "line",
            stack: "总量",
            data: [120, 132, 101, 134],
            areaStyle: {},
            smooth: true
          }
        ]
      };
      myChart.setOption(option);
    },
    myChart3() {
      let myChart = this.$echarts.init(
        document.getElementById("myChart3"),
        "dark"
      );
      myChart.setOption({
        backgroundColor: "",
        color: ["#e9dc81"],
        title: {
          text: "案件来源",
          textStyle: {
            fontSize: "16"
          },
          top: 20
        },
        tooltip: {},
        radar: {
          name: {
            textStyle: {
              fontSize: 12,
              color: "#04a8f2"
            },
            formatter: a => {
              return `${a}`;
            }
          },
          indicator: [
            { name: "行政执法单位", max: 6500 },
            { name: "互联网", max: 16000 },
            { name: "群众举报", max: 30000 },
            { name: "统一业务应用系统", max: 38000 },
            { name: "卫星影像", max: 52000 },
            { name: "其它", max: 25000 }
          ]
        },
        series: [
          {
            name: "",
            type: "radar",
            data: [
              {
                value: [5000, 14000, 28000, 31000, 42000, 21000],
                label: {
                  normal: {
                    show: true,
                    formatter: function (params) {
                      return params.value;
                    },
                    fontSize: 12,
                    color: "#04a8f2",
                    fontWeight: "bold"
                  }
                },
                itemStyle: {
                  color: "#e9dc81"
                }
              }
            ]
          }
        ]
      });
    },
    myChart7() {
      let myChart = this.$echarts.init(
        document.getElementById("myChart7"),
        "dark"
      );
      myChart.setOption({
        backgroundColor: "",
        color: ["#37A2DA", "#67E0E3", "#FFD85C", "#FF9F7F", "#E062AE"],
        title: {
          text: "案件统计",
          top: 20,
          textStyle: {
            fontSize: "16"
          }
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        legend: {
          bottom: 10,
          data: ["民事公益诉讼", "行政公益诉讼"],
          textStyle: {
            fontSize: 12
          }
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: ["50%", "70%"],
            label: {
              normal: {
                show: true,
                position: "inner",
                fontSize: 12,
                formatter: "{b}\n{d}%"
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: "16",
                  fontWeight: "bold"
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: [
              { value: 335, name: "民事公益诉讼" },
              { value: 310, name: "行政公益诉讼" }
            ]
          }
        ]
      });
    },
    myChart5() {
      let myChart = this.$echarts.init(
        document.getElementById("myChart5"),
        "dark"
      );
      myChart.setOption({
        backgroundColor: "",
        textStyle: {
          fontSize: 18
        },
        color: ["#4fdddb", "#6d5d87", "#38912e", "#bf5274", "#a1c108"],
        //color: ["#3398DB"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: "1%",
          right: "4%",
          bottom: "3%",
          top: "5%",
          height: "98%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: [
              "公安厅",
              "民政厅",
              "司法厅",
              // "财政厅",
              "自然资源厅",
              "生态环境厅",
              "住房和城乡建设厅",
              "交通运输厅",
              "水利厅",
              "农牧厅",
              "商务厅",
              "文化和旅游厅",
              "卫生健康委员会",
              // "退役军人事务厅",
              // "审计厅",
              "市场监督管理局",
              "能源局",
              "林业和草原局",
              // "地方金融监督管理局",
              // "医疗保障局",
              "文物局",
              "药品监督管理局"
            ],
            splitNumber: 1,
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              textStyle: {
                fontSize: 18
              },
              rotate: 55
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              textStyle: {
                fontSize: 18
              }
            }
          }
        ],
        series: [
          {
            name: "食品药品安全",
            type: "bar",
            data: [
              4100,
              6100,
              8100,
              7100,
              6500,
              5500,
              3500,
              7500,
              6100,
              6600,
              7100,
              7000,
              3500,
              5500,
              4500,
              6100,
              2100
            ]
          }
        ]
      });
    },
    myChart6() {
      let myChart = this.$echarts.init(
        document.getElementById("myChart6"),
        "dark"
      );
      myChart.setOption({
        backgroundColor: "",
        textStyle: {
          fontSize: 16
        },
        color: ["#4fdddb", "#6d5d87", "#38912e", "#bf5274", "#a1c108"],
        //color: ["#3398DB"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "2%",
          top: "5%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: [
              "文\n书\n鉴\n定",
              "痕\n迹\n鉴\n定",
              "声\n像\n资\n料",
              "环\n境\n损\n害",
              "司\n法\n会\n计",
              "计\n算\n机\n鉴\n定",
              "建\n筑\n工\n程",
              "知\n识\n产\n权",
              "产\n品\n质\n量",
              "化\n工\n类",
              "资\n产\n评\n估",
              "农\n业\n类",
              "水\n产\n类",
              "林\n业\n类",
              "矿\n产\n类",
              "其\n他"
            ],
            splitNumber: 1,
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              textStyle: {
                fontSize: 18
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              textStyle: {
                fontSize: 18
              }
            }
          }
        ],
        series: [
          {
            name: "食品药品安全",
            type: "bar",
            data: [
              4100,
              6100,
              1100,
              3500,
              4500,
              5500,
              6500,
              5500,
              7500,
              4500,
              1500,
              2500,
              7100,
              7000,
              2500,
              3500
            ]
          }
        ]
      });
    },
    myChart4() {
      let myChart = this.$echarts.init(
        document.getElementById("myChart4"),
        "dark"
      );
      myChart.setOption({
        backgroundColor: "",
        textStyle: {
          fontSize: 16
        },
        color: ["#4fa3af", "#6d5d87", "#38912e", "#bf5274", "#a1c108"],
        //color: ["#3398DB"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "12%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: ["2016", "2017", "2018", "2019"],
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              textStyle: {
                fontSize: 12
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              textStyle: {
                fontSize: 12
              }
            }
          }
        ],
        series: [
          {
            name: "食品药品安全",
            type: "bar",
            data: [4100, 6100, 8100, 7500]
          },
          {
            name: "国有土地使用权出让",
            type: "bar",
            data: [8000, 4500, 4600, 3800]
          },
          {
            name: "生态资源",
            type: "bar",
            data: [6300, 6400, 7800, 6200]
          },
          {
            name: "国有财产",
            type: "bar",
            data: [3800, 4100, 4200, 2500]
          },
          {
            name: "英烈权益",
            type: "bar",
            data: [4500, 3000, 4300, 5500]
          }
        ]
      });
    },
    myChart8() {
      let myChart = this.$echarts.init(
        document.getElementById("myChart8"),
        "dark"
      );
      let that = this;
      var size = [16, 40, 12, 13, 55, 18, 30, 50];

      const file = "/static/neimenggu.json";
      that.$axios.get(file).then(response => {
        this.$echarts.registerMap("neimenggu", response.data);
        myChart.setOption({
          backgroundColor: "",
          title: {
            text: '',
            textStyle: {
              fontSize: 16
            }
          },
          geo3D: {
            map: "neimenggu",
            height: 511,
            width: 690,
            label: {
              show: true,
              emphasis: {
                show: true
              },
              textStyle: {
                color: "#000",
                fontSize: 14,
                backgroundColor: "rgba(0,23,11,0)"
              }
            },
            viewControl: {
              zoomSensitivity: 0,
              panSensitivity: 0,
              rotateSensitivity: 0,
              alpha: 50,
              orthographicSize: 300
            },
            //shading :"color",
            emphasis: {
              //当鼠标放上去  地区区域是否显示名称
              label: {
                show: true,
                textStyle: {
                  color: "#000",
                  fontSize: 1,
                  backgroundColor: "rgba(0,23,11,0)"
                }
              }
            },
            roam: false, //是否允许缩放
            scaleLimit: {
              min: 1 //定义滚轮缩放的极限控制
            },
            itemStyle: {
              color: "#8df6ff",
              //areaColor: "rgb(141,245,255)",
              opacity: 1,
              borderWidth: 1,
              //borderColor: "rgb(62,215,213)"
              borderColor: "#759fd2"
            }
          },
          light: {
            //光照阴影
            main: {
              color: "#fff", //光照颜色
              intensity: 1.2, //光照强度
              //shadowQuality: 'high', //阴影亮度
              shadow: false, //是否显示阴影
              alpha: 55,
              beta: 10
            }
          },
          series: []
        });
      });
    }
  }
};
</script>

<style scoped>
@import url("../assets/css3d/htmleaf-demo.css");
@import url("../assets/css3d/normalize.css");

.main {
  background: url("../assets/zhi.png") no-repeat;
  background-size: 100%;
  width: 2880px;
  height: 1080px;
  color: #ffffff;
}

.border {
  background: url("../assets/border3.png") no-repeat;
  background-size: 100% 300px;
  width: 100%;
  height: 300px;
  padding: 5px 5px;
}

.diqiu {
  background: url("../assets/diqiu.png") no-repeat;
  background-size: 334px 263px;
  background-position: center;
  width: 100%;
  height: 263px;
  padding: 5px 5px;
}
.title {
  font-size: 50px;
}

.myChart {
  /* border: #ffffff 2px dashed; */
  width: 96%;
  padding: 5px 30px;
}

.border img {
  width: 120px;
  margin-left: 10px;
}

.box-title {
  text-align: left;
  font-size: 18px;
  margin-top: 30px;
  margin-bottom: 30px;
  margin-left: 40px;
}

.group {
  background: url("../assets/img_product/group.png") no-repeat;
  width: 450px;
  height: 275px;
  padding-left: 20px;
  margin-left: 50px;
}

.groupnumber {
  color: #75eaff;
}

.groupcontent {
  color: #bccad4;
}

.home {
  position: absolute;
  left: 147px;
  top: 44px;
  width: 120px;
  height: 96px;
  cursor: pointer;
}

.chart1 {
  position: absolute;
  left: 73px;
  top: 149px;
  width: 678px;
  height: 268px;
  border: 0px solid #ffffff;
}

.chart2 {
  position: absolute;
  left: 74px;
  top: 483px;
  width: 917px;
  height: 181px;
  border: 0px solid #ffffff;
}

.chart3 {
  position: absolute;
  left: 74px;
  top: 725px;
  width: 912px;
  height: 277px;
  border: 0px solid #ffffff;
  font-size: 14px;
  color: #9fbbd0;
  text-align: center;
}

.chart4 {
  position: absolute;
  left: 125px;
  top: 760px;
  width: 784px;
  height: 225px;
}

.chart5 {
  position: absolute;
  left: 1028px;
  top: 701px;
  width: 834px;
  height: 303px;
  border: 0px solid #ffffff;
}

.chart6 {
  position: absolute;
  left: 1923px;
  top: 497px;
  width: 543px;
  height: 195px;
  border: 0px solid #ffffff;
}

.chart7 {
  position: absolute;
  left: 2398px;
  top: 806px;
  width: 165px;
  height: 208px;
  border: 0px solid #ffffff;
}

.chart8 {
  position: absolute;
  left: 2603px;
  top: 812px;
  width: 138px;
  height: 188px;
  border: 0px solid #ffffff;
}

.chart3part2 {
  margin: 0 auto;
  font-size: 14px;
  color: #9fbbd0;
}
.xingzhengjibie {
  position: absolute;
  width: 340px;
  height: 260px;
  left: 80px;
  top: 150px;
  /* background: #75eaff; */
}
.fazhengjiguan {
  position: absolute;
  width: 340px;
  height: 260px;
  left: 410px;
  top: 150px;
  /* background: #75eaff; */
}

.navyin {
  position: absolute;
  left: 1585px;
  top: 473px;
  width: 100px;
  height: 100px;
  cursor: pointer;
  z-index: 1;
}
</style>
